import PropTypes from "prop-types";
// React
import { useEffect, useState } from "react";

// Material-UI
import { Typography } from "@mui/material";

// Components
import SelectionDialog from "@Layouts/components/Dialogs/SelectionDialog";

// Icons
import ManualGray from "@/assets/icons/motivators/specialUnits/ManualGray.svg";
import ManualBlue from "@/assets/icons/motivators/specialUnits/ManualBlue.svg";
import ManagedGray from "@/assets/icons/motivators/specialUnits/ManagedGray.svg";
import ManagedBlue from "@/assets/icons/motivators/specialUnits/ManagedBlue.svg";

export default function NewSpecialList(props) {
	const { open = false, addNewListCallBack = () => {}, onClose = () => {} } = props;

	const [loading, setLoading] = useState(false);
	const [selected, setSelected] = useState(null);
	const [disableClose, setDisableClose] = useState(false);

	const handleAddAction = (value) => {
		setLoading(true);
		setSelected(value);
		setDisableClose(true);
		addNewListCallBack?.(value);
	};

	useEffect(() => {
		setLoading(false);

		return () => {
			setLoading(false);
			setSelected(null);
			setDisableClose(false);
		};
	}, [open]);

	return (
		<SelectionDialog
			fullWidth
			disabledSecond={false}
			disableClose={disableClose}
			selected={selected}
			values={{
				first: "Managed",
				second: "Manual",
			}}
			firstContent={
				<Typography className="!font-sans !text-[14.5px] text-default" sx={{ mt: 1 }}>
					MANAGED: This option will create a Managed Special Units List.
				</Typography>
			}
			secondContent={
				<Typography className="!font-sans !text-[14.5px] text-default" sx={{ mt: 1 }}>
					MANUAL: This option will create a Manual Special Units List.
				</Typography>
			}
			buttonText={"Add New List"}
			loading={loading}
			icons={{
				first: <img src={ManagedGray} width={64} height={64} alt="icon" />,
				firstHover: <img src={ManagedBlue} width={64} height={64} alt="icon" />,
				second: <img src={ManualGray} width={64} height={64} alt="icon" />,
				secondHover: <img src={ManualBlue} width={64} height={64} alt="icon" />,
			}}
			open={open}
			sx={{
				"& .MuiPaper-root": {
					borderRadius: 4,
					maxWidth: "300px",
				},
			}}
			onClose={onClose}
			onAddAction={handleAddAction}
		/>
	);
}
NewSpecialList.propTypes = {
	open: PropTypes.bool,
	addNewListCallBack: PropTypes.func,
	onClose: PropTypes.func,
};
